// DEPENDENCIES
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Redirect, Route, Switch, useParams } from "react-router-dom";
// COMPONENTS
import { useSubheader } from "../../../../_metronic/layout";
// CUSTOM COMPONENTS
import JobManageCard from "./JobManageCard";
// PAGES
import JobDocumentPage from "./JobDocumentPage";
import JobGeneralInfoPage from "./JobGeneralInfoPage";
import JobCredentialAndTeamPage from "./JobCredentialAndTeamPage";
import JobSchedulePage from "./JobSchedulePage";
import JobFormsPage from "./JobFormsPage";
import JobTimeSheetPage from "./JobTimeSheetPage";
// SERVICES AND HELPERS
import * as jobService from "../../../../services/service/jobService";

const JobManagePage = (props) => {
    const { location, history } = props

    const [jobId] = useState(location.pathname.split('/').pop());
    const [jobInfo, setJobInfo] = useState({
        id: "",
        proposalId: "",
        projectNumber: "",
        awardedDateTime: "",
        projectName: "",
        formLeadId:0,
    })

    const suhbeader = useSubheader();
    suhbeader.setTitle("Manage Job");

    useEffect(() => {
        jobService.getJobCardInfo(jobId).then(res => {
            setJobInfo(res);
        })
    }, [history])

    return (
        <div className="d-flex flex-row">
            <JobManageCard jobId={jobId} jobInfo={jobInfo} {...props} />
            <div className="flex-row-fluid ml-lg-8">
                <Switch>
                    <Redirect
                        from="/services/manage-job/:id"
                        exact={true}
                        to="/services/manage-job/general-information/:jobId"
                    />
                    <Route
                        path="/services/manage-job/general-information/:jobId"
                        render={() => <JobGeneralInfoPage />}
                    />

                    <Route
                        path="/services/manage-job/team/:jobId"
                        render={() => <JobCredentialAndTeamPage jobInfo={jobInfo}/>}
                    />

                    <Route
                        path="/services/manage-job/schedule/:jobId"
                        render={() => <JobSchedulePage jobInfo={jobInfo}/>}
                    />

                    <Route
                        path="/services/manage-job/documents/:jobId"
                        render={() => <JobDocumentPage />}
                    />

                    <Route
                        path="/services/manage-job/forms/:jobId"
                        render={() => <JobFormsPage {...props} />}
                    />

                    <Route
                        path="/services/manage-job/timesheet/:jobId"
                        render={() => <JobTimeSheetPage {...props} jobInfo={jobInfo} />}
                    />
                </Switch>
            </div>
        </div>
    );
}

export default connect(null, null)(JobManagePage);